import { useEffect, useRef, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import { STRINGS } from "../constant";
import { IMAGES } from "../assets";
import { PremiumView, LAWarningPopup } from "../components";
import { UPLOAD_PROFILE } from "../api/firebase_user";
import { RESET_USER_QUESTIONS_COLLECTION } from "../api/questions";
import { useNavigate } from "react-router-dom";
import { auth } from "../api/config";
import moment from "moment";
import { useContext } from "react";
import { AuthContext } from "../context/AuthProvider";
import { ThemeContext } from "../context/ThemeProvider";
import { IS_BUNDLE_APP, STRING } from "../../app_constant";
import { SHOW_TOAST } from "../constant/utils";
import { MixpanelContext } from "../context/MixpanelProvider";
import SupportEmailForm from "../components/SupportEmailForm";
import BackArrowIcon from "../components/BackArrowIcon";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createLogger } from "../utils/logger";
import { getIOSURL, getAndroidURL } from "../api/client";
import { 
  faUser, 
  faCamera, 
  faCog, 
  faUndo, 
  faEnvelope, 
  faSignOutAlt, 
  faChevronRight,
  faMobileAlt,
  faUserCircle,
  faQuestionCircle,
  faCrown,
  faMobileScreen,
  faMobileScreenButton
} from '@fortawesome/free-solid-svg-icons';
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';
import useFeatureList from "../hooks/useFeatureList";

function Profile() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isCameraView, setIsCameraView] = useState(false);
  const [isReset, setIsReset] = useState(false);
  const [image, setImage] = useState(null);
  const [isImagePicker, setImagePicker] = useState(false);
  const [tempImage, setTempImage] = useState("");
  const { theme, currentTheme } = useContext(ThemeContext);
  const [customerPortalLink, setCustomerPortalLink] = useState(null);
  const [daysLeft, setDaysLeft] = useState(null);
  const { mySubscription, loggingEnabled } = useContext(AuthContext);
  const featureList = useFeatureList();
  
  const logger = createLogger(loggingEnabled);

  const fileInputRef = useRef(null);

  const {
    bundleData,
    profile,
    setProfilePicture,
    setBundleProfilePicture,
    setNewProfile,
    setBundleProfile,
    isSubscribe,
  } = useContext(AuthContext);
  const { trackAccountSetting, trackResetApp, trackReviewApp } =
    useContext(MixpanelContext);
  const { resetMixpanel } = useContext(MixpanelContext);

  const [isDialogOpen, setDialogOpen] = useState(false);
  useEffect(() => {
    if (mySubscription?.subscription_expiration) {
      const endDate = new Date(mySubscription.subscription_expiration.toDate());
      const today = new Date();
      const diffTime = endDate.getTime() - today.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
      setDaysLeft(diffDays > 0 ? diffDays : 0);
    } else {
      setDaysLeft(null);
    }
  }, [mySubscription]);

  // Card animations
  const cardVariants = {
    hover: { 
      scale: 1.02,
      boxShadow: "0px 8px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  // Helper function to get icon background color
  const getIconBg = () => {
    return currentTheme === 'light' ? theme?.icon_bg?.profile_light : theme?.icon_bg?.profile_dark;
  }

  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark; 
    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      borderLeft: `4px solid ${iconBg || (currentTheme === 'light' ? theme?.icon_bg?.profile_light : theme?.icon_bg?.profile_dark)}`
    };
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  const handleOpenDialog = () => setDialogOpen(true);
  const handleCloseDialog = () => setDialogOpen(false);

  async function onSignOut() {
    setLoading(true);
    await auth().signOut();
    setLoading(false);
    resetMixpanel();
    navigate("/login");
    localStorage.removeItem("appState");
  }

  function getUserImage() {
    if (tempImage) {
      setImage(tempImage);
    } else if (IS_BUNDLE_APP && bundleData?.profile_pic) {
      setImage(bundleData.profile_pic);
    } else if (IS_BUNDLE_APP == false && profile?.profile_pic) {
      setImage(profile?.profile_pic);
    } else {
      setImage(IMAGES.ic_user_home);
    }
  }

  const getBundleDetails = async () => {
    try {
    } catch (err) {
      logger.error(err);
    }
  };

  useEffect(() => {
    getBundleDetails();
  }, []);

  useEffect(() => {
    getUserImage();
  }, [profile, bundleData]);

  const handleFileUpload = () => {
    fileInputRef.current.click();
  };

  const handleFileSelected = async (e) => {
    let file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      fileInputRef.current.value = null;
      setTempImage(imageUrl);
      setImage(imageUrl);
      setImagePicker(false);
      const result = await UPLOAD_PROFILE(file);
      setLoading(false);
      if (result.status) {
        if (IS_BUNDLE_APP) {
          setBundleProfilePicture(result.url);
        } else {
          setProfilePicture(result.url);
        }
      } else {
        SHOW_TOAST(result.error ?? "");
      }
    }
  };

  const getPlanExpiry = () => {
    logger.log("mySubscription", mySubscription);
    if (mySubscription?.subscription_expiration) {
      const endDate = new Date(mySubscription.subscription_expiration.toDate());
      return moment(endDate).format("MMM D, YYYY");
    }
    return null;
  };


  async function resetData() {
    await RESET_USER_QUESTIONS_COLLECTION();
    const data = {
      auth_first_name: profile?.auth_first_name ?? "",
      auth_last_name: profile?.auth_last_name ?? "",
      auth_email: profile?.auth_email ?? "",
      auth_login_provider: profile?.auth_login_provider ?? "",
      last_signin_time: IS_BUNDLE_APP
        ? profile?.last_signin_time ?? ""
        : auth().currentUser.metadata?.lastSignInTime ?? "",
      flashcard_bookmarks: [],
      flashcards_progress: [],
      practice_test_history: [],
      question_bookmarks: [],
      questions_progress: [],
      quiz_of_the_day_reminder: true,
      signup_date: IS_BUNDLE_APP
        ? profile?.signup_date ?? ""
        : auth().currentUser.metadata?.creationTime ?? "",
      study_plan_reminder: true,
      profile_pic: "",
      readiness_scores: null,
      score_progress: {},
      ...(profile?.isQuestionLatestVersionUpdated !== undefined && { isQuestionLatestVersionUpdated: profile.isQuestionLatestVersionUpdated }),
    };
    setNewProfile(data);
    if (IS_BUNDLE_APP) {
      const dataBundle = {
        auth_first_name: bundleData?.auth_first_name ?? "",
        auth_last_name: bundleData?.auth_last_name ?? "",
        auth_email: bundleData?.auth_email ?? "",
        auth_login_provider:
          auth().currentUser?.providerData[0]?.providerId ?? "",
        last_signin_time: auth().currentUser.metadata?.lastSignInTime ?? "",
        signup_date: auth().currentUser.metadata?.creationTime ?? "",
        profile_pic: "",
      };
      setBundleProfile(dataBundle);
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      moveToHome();
    }, 1000);
  }

  async function moveToHome() {
    navigate();
    navigate("/prepare", {
      state: {
        isFromOnboarding: true,
      },
    });
  }

  const handleFetchCustomerPortalLink = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const functionRef = firebase
        .app()
        .functions("us-central1")
        .httpsCallable("ext-firestore-stripe-payments-createPortalLink");
      const { data } = await functionRef({
        returnUrl: `${window.location.origin}/prepare`,
        locale: "auto",
      });
      setCustomerPortalLink(data.url);
      setLoading(false);
      window.open(data.url, "_blank");
    } catch (error) {
      logger.error("Error fetching customer portal link:", error);
      setLoading(false);
    }
  };

  const handleSharing = async () => {
    if (navigator.share) {
      try {
        await navigator
          .share({
            url: "https://isc2-learnzapp.web.app",
            title: "ISC2 Official App",
            text: "https://isc2-learnzapp.web.app",
          })
          .then(() =>
            logger.log("Hooray! Your content was shared to tha world")
          );
      } catch (error) {
        logger.log(`Oops! I couldn't share to the world because: ${error}`);
      }
    } else {
      logger.log(
        "Web share is currently not supported on this browser. Please provide a callback"
      );
    }
  };

  const expiryDate = getPlanExpiry();

  const profileData = {
    "account_setting": featureList?.profile.account_setting,
    "settings": featureList?.profile.settings,
    "reset_app_data": featureList?.profile.reset_app_data,
    "other_apps": featureList?.profile.other_apps,
    // "contact_support": featureList?.profile.contact_support,
  };

  const getProfileIcon = (key) => {
    switch(key) {
      case "account_setting": return faUserCircle;
      case "settings": return faCog;
      case "reset_app_data": return faUndo;
      // case "contact_support": return faEnvelope;
      default: return faQuestionCircle;
    }
  };

  const profileItems = [
    { key: "account_setting", name: "Account Setting", route: "/account" },
    { key: "settings", name: "Settings", route: "/testSetting" },
    { key: "reset_app_data", name: "Reset App Data", action: () => setIsReset(true) },
    // { key: "contact_support", name: "Got Questions? Contact Support", action: handleOpenDialog }
  ];

  return (
    <div className="p-6">
      {/* Header Section */}
      <div className="flex items-center mb-6">
        <button
          className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
          style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
          onClick={() => navigate("/home")}
        >
          <BackArrowIcon
            color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
          />
        </button>
        <h1 
          className="text-2xl font-semibold"
          style={{ color: getTextColor() }}
        >
          Profile
        </h1>
      </div>
      

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Profile Card */}
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
          whileHover="hover"
          variants={cardVariants}
        >
          <div style={getCardBackground(getIconBg())}>
            <div className="p-6">
              <div className="flex items-center mb-6">
                <div className="relative">
                  <div 
                    className="w-24 h-24 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center"
                    style={{ border: `2px solid ${getIconBg()}` }}
                  >
                    <img
                      src={image}
                      alt="Profile"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <button 
                    className="absolute bottom-0 right-0 w-8 h-8 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: getIconBg() }}
                    onClick={() => setImagePicker(true)}
                  >
                    <FontAwesomeIcon 
                      icon={faCamera} 
                      className="text-white text-sm" 
                    />
                  </button>
                </div>
                <div className="ml-6">
                  <h2 
                    className="text-xl font-semibold"
                    style={{ color: getTextColor() }}
                  >
                    {IS_BUNDLE_APP
                      ? `${bundleData?.auth_first_name || ''} ${bundleData?.auth_last_name || ''}`
                      : `${profile?.auth_first_name || ''} ${profile?.auth_last_name || ''}`}
                  </h2>
                  <p className="text-gray-500 dark:text-gray-400 mt-1">
                    {IS_BUNDLE_APP ? bundleData?.auth_email || "" : profile?.auth_email || ""}
                  </p>
                  
                </div>
              </div>

              
                <div 
                  className="p-4 rounded-lg mb-6"
                  style={{ backgroundColor: currentTheme === 'light' ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.05)' }}
                >
                  <p 
                    className="text-sm font-medium"
                    style={{ color: getTextColor() }}
                  >
                    Premium access expires on:
                    <span className="font-bold ml-1">{expiryDate}</span>
                  </p>
                  
                  {bundleData?.subscription?.paymentType === "recurring" && (
                    <button 
                      onClick={handleFetchCustomerPortalLink}
                      className="mt-2 text-sm font-medium px-4 py-2 rounded-lg"
                      style={{ backgroundColor: getIconBg(), color: '#ffffff' }}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Manage Subscription"}
                    </button>
                  )}
                </div>
              

              

              {featureList?.profile.sign_out && (
                <div className="flex justify-center">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={onSignOut}
                    className="flex items-center px-6 py-2 rounded-lg border-2 font-medium"
                    style={{ color: getTextColor(), borderColor: currentTheme === 'light' ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.2)' }}
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                    {STRINGS.sign_out}
                  </motion.button>
                </div>
              )}
            </div>
          </div>
        </motion.div>
        

        {/* Profile Options */}
        <div className="space-y-3">
          {profileItems
            .filter(item => profileData[item.key])
            .map((item, index) => (
              <ProfileItem
                key={index}
                item={item}
                icon={getProfileIcon(item.key)}
                iconBg={getIconBg()}
                textColor={getTextColor()}
                getCardBackground={getCardBackground}
                onClick={() => {
                  if (item.route) {
                    navigate(item.route);
                  } else if (item.action) {
                    item.action();
                  }
                }}
              />
            ))}
        </div>
      </div>

      {/* Download App Card */}
      <div className="mt-6 md:w-1/2">
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
          whileHover="hover"
          variants={cardVariants}
        >
          <div style={getCardBackground(getIconBg())}>
            <div className="p-6">
              <h3 
                className="text-xl font-semibold mb-6"
                style={{ color: getTextColor() }}
              >
                Download The App
              </h3>
              
              <div className="space-y-4">
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={async () => {
                    const iosUrl = await getIOSURL();
                    window.open(iosUrl, '_blank');
                  }}
                  className="w-full flex items-center px-4 py-3 rounded-lg"
                  style={{ 
                    backgroundColor: currentTheme === 'light' ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.05)',
                    color: getTextColor()
                  }}
                >
                  <FontAwesomeIcon icon={faApple} className="mr-3 text-xl" />
                  <span>Download for iOS</span>
                  <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                </motion.button>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={async () => {
                    const androidUrl = await getAndroidURL();
                    window.open(androidUrl, '_blank');
                  }}
                  className="w-full flex items-center px-4 py-3 rounded-lg"
                  style={{ 
                    backgroundColor: currentTheme === 'light' ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.05)',
                    color: getTextColor()
                  }}
                >
                  <FontAwesomeIcon icon={faGooglePlay} className="mr-3 text-xl" />
                  <span>Download for Android</span>
                  <FontAwesomeIcon icon={faChevronRight} className="ml-auto" />
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {isDialogOpen && (
        <SupportEmailForm
          handleCloseDialog={handleCloseDialog}
          isLoading={false}
          setLoading={() => {}}
        />
      )}

      {isReset && (
        <LAWarningPopup
          onCancle={() => {
            setIsReset(false);
          }}
          onPress={(e, index) => {
            if (index === 0) {
              setIsReset(false);
            } else {
              resetData();
            }
          }}
          options={[STRINGS.no, STRINGS.reset]}
          title={STRINGS.reset_data}
          desc={STRINGS.reset_data_message}
        />
      )}

      {isImagePicker && (
        <LAWarningPopup
          setIsCameraView={setIsCameraView}
          setImagePicker={setImagePicker}
          setImage={setImage}
          isCameraView={isCameraView}
          iconHide={true}
          image={IMAGES.ic_camera}
          cancelText={STRING?.cancel}
          options={["Cancel", STRINGS?.camera, STRINGS?.photo_library]}
          onCancle={() => {
            setImagePicker(false);
          }}
          onPress={async (index) => {
            if (index === "Camera") {
              setIsCameraView(true);
            } else if (index === "Photo Library") {
              handleFileUpload();
            } else if (index === "Cancel") {
              setImagePicker(false);
            }
          }}
        />
      )}

      <input
        accept="image/*"
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={(e) => handleFileSelected(e)}
      />
    </div>
  );
}

function ProfileItem({ item, icon, iconBg, textColor, getCardBackground, onClick }) {
  const cardVariants = {
    hover: { 
      scale: 1.02,
      boxShadow: "0px 8px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  return (
    <motion.div
      className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm cursor-pointer"
      onClick={onClick}
      whileHover="hover"
      variants={cardVariants}
    >
      <div style={getCardBackground(iconBg)}>
        <div className="p-4">
          <div className="flex items-center">
            <div 
              className="w-10 h-10 rounded-full flex items-center justify-center mr-4"
              style={{ backgroundColor: iconBg }}
            >
              <FontAwesomeIcon 
                icon={icon} 
                className="text-white" 
              />
            </div>
            <span 
              className="flex-1 font-medium"
              style={{ color: textColor }}
            >
              {item.name}
            </span>
            <FontAwesomeIcon 
              icon={faChevronRight} 
              style={{ color: textColor }}
            /> 
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Profile;